// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__jwHD_","right":"styles_right__1gKaM"};